<template>
  <div class="game">
    <div id="game5"></div>
    <van-popup v-model="info" position="top" :style="{ height: '60%' }">
      <div class="info">
        <h1>飞刀游戏说明</h1>
        <ul>
          <li>点击飞刀，投掷飞刀，刺入木桩。</li>
          <li>每次投掷，消耗100金豆。</li>
          <li>
            每次投掷成功，奖励金豆会增加,增加规则为：1000分以下，x2；1000分以上，+1000。
          </li>
          <li>点击 [ 领取奖励 ] ，可以领取奖励的金豆，并且游戏重新开始。</li>
          <li>
            投掷的飞刀碰到其他飞刀，则投掷失败，奖励金豆清零，并且游戏重新开始。
          </li>
          <li>
            飞刀游戏，每天可参与10次。
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Cell, CellGroup } from "vant";
import { Popup } from "vant";

Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
import { getUserInfo } from "@api/user";
import {
  game5_config,
  game5_throwKnife,
  game5_success,
  game5_fail
} from "@api/game";
import Phaser from "phaser";
let game, vm;
let gameOptions = {
  rotationSpeed: 3,
  throwSpeed: 150,
  minAngle: 15,
  rotationVariation: 2,
  changeTime: 2000,
  maxRotationSpeed: 6
};
let fontOpt = {
  fontFamily: "Arial Black",
  fontSize: 40,
  color: "#c51b7d",
  align: "center"
};

let run = false,
  score,
  score_get,
  score_use,
  playTimes,
  getScoreBtn,
  timer,
  time_s,
  time_label;

function onEvent() {
  time_s--;
  time_label.setText(time_s);
  if (time_s <= 0) {
    timer.paused = true;
    end();
  }
  console.log("tick");
}

function end() {
  if (run) {
    //检测游戏次数
    if (vm.noTimes()) {
      return;
    }
    if (vm.game_money_use === 0) {
      vm.cancel();
    } else {
      vm.play_times_today++;
      playTimes.setText(
        "剩余次数: " + (vm.play_times_today_max - vm.play_times_today)
      );
      // if (vm.game_money_get > 0) {
      vm.game_money = vm.game_money + vm.game_money_get;
      score.setText("金豆: " + vm.game_money);
      score_get.setText("当前奖励: 0");
      score_use.setText("消耗金豆: 0");
      vm.success();
    }

    run = false;
    timer.paused = true;
    getScoreBtn.setFrame(1);
    // }
  } else {
    //检测游戏次数
    if (vm.noTimes()) {
      return;
    }
    time_s = 10;
    time_label.setText(time_s);
    timer.paused = false;
    //   vm.reload();
    vm.game_money_get = 0;
    vm.game_money_use = 0;
    score_get.setText("当前奖励: " + vm.game_money_get);
    score_use.setText("消耗金豆: " + vm.game_money_use);
    getScoreBtn.setFrame(0);

    var scene = game.scene.keys["PlayGame"];
    scene.knifeGroup.clear(true, true);

    scene.canThrow = true;
    scene.canThrow = true;
    scene.knife = scene.add
      .sprite(game.config.width / 2, (game.config.height / 5) * 4, "knife")
      .setInteractive();
    scene.target = scene.add.sprite(game.config.width / 2, 450, "target");
    scene.target.depth = 1;
    scene.knife.on("pointerdown", throwKnife, scene);

    run = true;
  }
}

class playGame extends Phaser.Scene {
  constructor() {
    super("PlayGame");
  }
  preload() {
    this.load.setBaseURL("https://admin.mingpinjixuan.com");

    this.load.image("bg", "/games/game5/bg.jpg");
    this.load.image("target", "games/game5/target.png");
    this.load.image("knife", "/games/game5/knife.png");
    this.load.image("back", "/games/game5/back.png");
    this.load.spritesheet("btns", "/games/game5/btns.png", {
      frameWidth: 131,
      frameHeight: 50
    });

    this.load.audio("feidao", "/games/game5/feidao1.mp3");
    this.load.audio("pz", "/games/game5/pz1.mp3");
  }
  create() {
    this.add
      .image(game.config.width / 2, 0, "bg")
      .setOrigin(0.5, 0)
      .setScale(1.6);

    timer = this.time.addEvent({
      delay: 1000,
      callback: onEvent,
      callbackScope: this,
      loop: true
    });
    timer.paused = true;

    // this.add
    //   .text(10, 10, "返回", fontOpt)
    //   .setAlpha(1)
    //   .setOrigin(0, 0)
    //   .setInteractive()
    //   .on("pointerdown", function() {
    //     vm.back();
    //   });

    this.add
      .sprite(10, 10, "back")
      .setAlpha(1)
      .setOrigin(0, 0)
      .setInteractive()
      .setScale(1.2)
      .on("pointerdown", function() {
        vm.back();
      });

    getScoreBtn = this.add
      .sprite(10, game.config.height - (vm.ua === "IOS" ? 60 : 10), "btns")
      .setAlpha(1)
      .setOrigin(0, 1)
      .setInteractive()
      .setScale(1.5)
      .setFrame(run ? 0 : 1)
      .on("pointerdown", end);

    // this.add
    //   .text(
    //     game.config.width - 10,
    //     game.config.height - 10,
    //     "游戏说明",
    //     fontOpt
    //   )
    //   .setAlpha(1)
    //   .setOrigin(1, 1)
    //   .setInteractive()
    //   .on("pointerdown", function() {
    //     vm.showInfo();
    //   });
    this.add
      .sprite(
        game.config.width - 10,
        game.config.height - (vm.ua === "IOS" ? 60 : 10),
        "btns"
      )
      .setAlpha(1)
      .setOrigin(1, 1)
      .setInteractive()
      .setScale(1.5)
      .setFrame(2)
      .on("pointerdown", function() {
        vm.showInfo();
      });

    score = this.add
      .text(game.config.width - 10, 10, "金豆: " + vm.game_money, fontOpt)
      .setAlpha(1)
      .setOrigin(1, 0);

    score_use = this.add
      .text(game.config.width - 10, 60, "消耗金豆: 0", fontOpt)
      .setAlpha(1)
      .setOrigin(1, 0);

    score_get = this.add
      .text(game.config.width - 10, 110, "奖励金豆: 0", fontOpt)
      .setAlpha(1)
      .setOrigin(1, 0);

    playTimes = this.add
      .text(
        game.config.width - 10,
        160,
        "剩余次数: " + (vm.play_times_today_max - vm.play_times_today),
        fontOpt
      )
      .setAlpha(1)
      .setOrigin(1, 0);

    this.currentRotationSpeed = gameOptions.rotationSpeed;
    this.newRotationSpeed = gameOptions.rotationSpeed;
    this.knifeGroup = this.add.group();
    // gameInit.bind(this);
    this.canThrow = true;

    this.knife = this.add
      .sprite(game.config.width / 2, (game.config.height / 5) * 4, "knife")
      .setInteractive();
    this.knife.on("pointerdown", throwKnife, this);

    this.target = this.add.sprite(game.config.width / 2, 450, "target");
    this.target.depth = 1;

    time_label = this.add
      .text(game.config.width / 2, 450, time_s, {
        fontFamily: "Arial Black",
        fontSize: 120,
        color: "#ff0000",
        align: "center"
      })
      .setAlpha(1)
      .setOrigin(0.5, 0.5);
    time_label.depth = 2;

    var timedEvent = this.time.addEvent({
      delay: gameOptions.changeTime,
      callback: function() {
        var sign = Phaser.Math.Between(0, 1) == 0 ? -1 : 1;
        var variation = Phaser.Math.FloatBetween(
          -gameOptions.rotationVariation,
          gameOptions.rotationVariation
        );
        this.newRotationSpeed = (this.currentRotationSpeed + variation) * sign;
        this.newRotationSpeed = Phaser.Math.Clamp(
          this.newRotationSpeed,
          -gameOptions.maxRotationSpeed,
          gameOptions.maxRotationSpeed
        );
      },
      callbackScope: this,
      loop: true
    });
  }
  update(time, delta) {
    if (run) {
      this.target.angle += this.currentRotationSpeed;
      var children = this.knifeGroup.getChildren();
      for (var i = 0; i < children.length; i++) {
        children[i].angle += this.currentRotationSpeed;
        var radians = Phaser.Math.DegToRad(children[i].angle + 90);
        children[i].x =
          this.target.x + (this.target.width / 2) * Math.cos(radians);
        children[i].y =
          this.target.y + (this.target.width / 2) * Math.sin(radians);
      }
      this.currentRotationSpeed = Phaser.Math.Linear(
        this.currentRotationSpeed,
        this.newRotationSpeed,
        delta / 1000
      );
    }
  }
}

var throwKnife = function() {
  console.log(run);
  if (!run) return;
  //检测游戏次数
  if (vm.noTimes()) {
    return;
  }
  if (vm.game_money < vm.throw_score) {
    return;
    vm.notMoney();
  }
  if (this.canThrow) {
    this.canThrow = false;
    vm.throwKnife();
    this.sound.add("feidao").play();
    vm.game_money -= vm.throw_score;
    score.setText("金豆: " + vm.game_money);
    //game_money_use
    vm.game_money_use += vm.throw_score;
    score_use.setText("消耗金豆: " + vm.game_money_use);
    this.tweens.add({
      targets: [this.knife],
      y: this.target.y + this.target.width / 2,
      duration: gameOptions.throwSpeed,
      callbackScope: this,
      onComplete: function(tween) {
        var legalHit = true;
        var children = this.knifeGroup.getChildren();
        for (var i = 0; i < children.length; i++) {
          if (
            Math.abs(
              Phaser.Math.Angle.ShortestBetween(
                this.target.angle,
                children[i].impactAngle
              )
            ) < gameOptions.minAngle
          ) {
            legalHit = false;
            break;
          }
        }
        if (legalHit) {
          this.canThrow = true;
          var knife = this.add.sprite(this.knife.x, this.knife.y, "knife");
          knife.impactAngle = this.target.angle;
          this.knifeGroup.add(knife);
          this.knife.y = (game.config.height / 5) * 4;
          console.log("a");
          vm.game_money_get = vm.game_money_get
            ? vm.game_money_get > 1000
              ? vm.game_money_get + 1000
              : vm.game_money_get * 2
            : 2;
          score_get.setText("当前奖励: " + vm.game_money_get);
        } else {
          this.sound.add("pz").play();
          timer.paused = true;
          this.tweens.add({
            targets: [this.knife],
            y: game.config.height + this.knife.height,
            rotation: 5,
            duration: gameOptions.throwSpeed * 4,
            callbackScope: this,
            onComplete: function(tween) {
              this.knife.destroy();
              console.log("b");
              vm.fail();
              vm.play_times_today++;
              playTimes.setText(
                "剩余次数: " + (vm.play_times_today_max - vm.play_times_today)
              );
              score_get.setText("当前奖励: 0");
              run = false;
              getScoreBtn.setFrame(1);
              // this.scene.start("playGame");
            }
          });
        }
      }
    });
  }
};
export default {
  name: "Game5",
  data() {
    return {
      ua: this.$store.state.userAgent,
      info: false,
      config: {
        type: Phaser.AUTO,
        width: window.innerWidth * 2,
        height: window.innerHeight * 2,
        backgroundColor: "#08080800",
        parent: "game5",
        scale: {
          mode: Phaser.Scale.ScaleModes.ENVELOP
        },
        scene: playGame
      },
      throw_score: 100,
      user_id: 0,
      game_money: 0,
      game_log: [],
      play_times_today: 10,
      game_money_get: 0,
      game_money_use: 0,

      play_times_today_max: 10
    };
  },
  mounted: function() {
    this.init();
    vm = this;
    time_s = 10;
    run = false;
    // window.focus();
    // this.resize();
    // window.addEventListener("resize", this.resize, false);
  },
  watch: {
    info(newVal) {
      if (newVal) {
        game.scene.keys["PlayGame"].sys.sleep();
      } else {
        game.scene.keys["PlayGame"].sys.wake();
      }
    }
  },
  methods: {
    init() {
      let that = this;
      getUserInfo().then(res => {
        that.user_id = res.data.uid;
        game5_config({ user_id: that.user_id }).then(res => {
          this.throw_score = res.data.throw_score;
          that.game_money = parseFloat(res.data.game_money);
          that.play_times_today_max = parseInt(res.data.free_play_times);
          // that.game_log = res.data.game_log;
          that.play_times_today =
            res.data.play_times_today > this.play_times_today_max
              ? this.play_times_today_max
              : res.data.play_times_today;

          game = new Phaser.Game(that.config);
        });
      });
    },
    back() {
      this.$router.push({ path: "/user" });
    },
    throwKnife() {
      game5_throwKnife({ user_id: this.user_id }).then(() => {});
    },
    cancel() {
      this.$dialog.toast({
        mes: "未进行游戏,请重新开始"
      });
    },
    success() {
      // if (this.game_money_get === 0) {
      //   this.$dialog.toast({ mes: "没有赢得积分" });
      //   this.game_money_get = 0;
      // } else {
      game5_success({
        user_id: this.user_id,
        score: this.game_money_get,
        use: this.game_money_use
      }).then(() => {
        this.$dialog.toast({
          mes: "领取金豆: " + this.game_money_get + "<br>请点击重新开始继续游戏"
        });
        this.game_money_get = 0;
      });
      // }
      console.log("success");
      //添加积分
    },
    fail() {
      game5_fail({ user_id: this.user_id, score: this.game_money_use }).then(
        () => {}
      );
      this.$dialog.toast({
        mes:
          "任务失败<br>消耗 " +
          this.game_money_use +
          " 金豆<br>损失 " +
          this.game_money_get +
          " 金豆<br>请点击重新开始继续游戏"
      });
      this.game_money_use = 0;
      this.game_money_get = 0;
    },
    notMoney() {
      this.$dialog.toast({
        mes: "金豆不足"
      });
    },
    showInfo() {
      this.info = true;
    },
    noTimes() {
      if (this.play_times_today < this.play_times_today_max) {
        return false;
      } else {
        this.$dialog.toast({
          mes: "游戏次数用完，明天再来吧"
        });
        return true;
      }
    }
    // resize() {
    //   var canvas = document.querySelector("canvas");
    //   var windowWidth = window.innerWidth;
    //   var windowHeight = window.innerHeight;
    //   var windowRatio = windowWidth / windowHeight;
    //   var gameRatio = game.config.width / game.config.height;
    //   if (windowRatio < gameRatio) {
    //     canvas.style.width = windowWidth + "px";
    //     canvas.style.height = windowWidth / gameRatio + "px";
    //   } else {
    //     canvas.style.width = windowHeight * gameRatio + "px";
    //     canvas.style.height = windowHeight + "px";
    //   }
    // }
  },

  beforeDestroy: function() {
    if (game) {
      game.destroy();
    }
  }
};
</script>
<style scoped>
.info {
  font-size: 16px;
  padding: 15px 0;
}
.info h1 {
  font-size: 24px;
  text-align: center;
  margin: 25px 0 5px 0;
}
.info ul {
  list-style: disc;
  margin: 30px;
}
.info ul li {
  margin-bottom: 12px;
}
.game {
  height: 100%;
}
</style>
